import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useSearchParams } from 'react-router';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { isType } from '@sorare/core/src/lib/gql';

import { BuyGemsDialog } from 'components/commonCard/BuyGemsDialog';

import type {
  BuyGemsDialogQuery,
  BuyGemsDialogQueryVariables,
} from './__generated__/index.graphql';

const BUY_GEMS_DIALOG_QUERY = gql`
  query BuyGemsDialogQuery {
    market {
      id
      gemsPacks: inGameCurrencyPacks(sport: FOOTBALL, currency: COMMON_GEM) {
        id
        ...BuyGemsDialog_inGameCurrencyPack
      }
    }
    tokens {
      purchasableItems(sport: FOOTBALL) {
        slug
        ...BuyGemsDialog_inGameCurrencyPurchasableItem
      }
    }
  }
  ${BuyGemsDialog.fragments.inGameCurrencyPack}
  ${BuyGemsDialog.fragments.inGameCurrencyPurchasableItem}
` as TypedDocumentNode<BuyGemsDialogQuery, BuyGemsDialogQueryVariables>;

export const SearchParamBasedBuyGemsDialog = () => {
  const {
    flags: { usePurchasableItemId = false },
  } = useFeatureFlags();

  const [searchParams, setSearchParams] = useSearchParams();
  const buyGems = searchParams.get('buy_gems');
  const { data } = useQuery(BUY_GEMS_DIALOG_QUERY, {
    skip: !buyGems,
  });
  const { market } = data || {};
  const { tokens } = data || {};
  const gemsPacks = (() => {
    if (usePurchasableItemId) {
      return (
        tokens?.purchasableItems
          .map(item =>
            isType(item, 'InGameCurrencyPurchasableItem') ? item : null
          )
          .filter(Boolean) || []
      );
    }
    return market?.gemsPacks;
  })();
  return (
    <BuyGemsDialog
      open={!!buyGems}
      onClose={() => {
        searchParams.delete('buy_gems');
        setSearchParams(searchParams, {
          replace: true,
        });
      }}
      gemsPacks={gemsPacks}
    />
  );
};
